﻿import {UpdateHolderArguments} from "../../types/arguments/UpdateHolderArguments";
import {HolderDataResult} from "../../types/HolderDataResult";
import IPermitsHolder from "../IPermitsHolder";
import {PermitsFrontClient} from "./PermitsFrontClient";

export class PermitsHolder implements IPermitsHolder {
	_client: PermitsFrontClient;

	constructor(client: PermitsFrontClient) {
		this._client = client;
	}

	get(signal?: AbortSignal | undefined): Promise<HolderDataResult> {
		return this._client.jsonFetch("holders", "GET", null, {
			signal: signal
		});
	}

	update(data: UpdateHolderArguments, signal?: AbortSignal | undefined): Promise<void> {
		return this._client.nullFetch("holders", "PUT", data, {
			signal: signal
		});
	}
}
